class Zoombini {
  // When we create a new Zoombini we run this function; it's called the constructor and you can see it taking our image in from above
  constructor(targetImage,settings){
    this.settings = settings;
    // We don't want the Zoombini to forget about it's image, so let's save that info
    this.image = targetImage;
    this.image.style.cursor = "zoom-in";
    this.image.setAttribute('draggable', false);

    this.computeParentBounds();

    // The Zoombini isActive after it has opened up 
    this.isActive = false;
    // But as it hasn't been used yet it's maskSize will be 0
    this.maskSize = 0;
    // And we have to start it's coordinates somewhere, they may as well be (0,0)
    this.mousex = this.mousey = 0;
    
    // Now we're set up let's build the necessary compoonents
    // First let's clone our original image, I'm going to call it imageZoom and save it our Zoombini
    console.log("create imageZoom");
    this.imageZoom = this.image.cloneNode();

    // ==================================================
    // THIS IS HACKY. May screw up other use-cases
    this.image.parentNode.style.position = "relative";
    // ==================================================

    // And pop it next to the image target
    this.image.parentNode.insertBefore(this.imageZoom,this.image);
    // Make the zoom image that we'll crop float above it's original sibling
    this.imageZoom.style.zIndex = 1;
    this.imageZoom.style.maxHeight = 'unset';
    this.imageZoom.style.maxWidth = 'unset';

    // We don't want to be able to touch it though, we want to reach whats underneat
    this.imageZoom.style.pointerEvents = "none";
    // And so we can translate it let's make it absolute
    this.imageZoom.style.position = "absolute";
    
    // Now let's scale up our enlarged image and add an event listener so that it resizes whenever the size of the window changes
    this.resizeImageZoom();
    window.addEventListener("resize", this.resizeImageZoom.bind(this), false);
    
    // Now that we're finishing the constructor we need to addeventlisteners so we can interact with it
    // This function is just below, but still exists within our Zoombini
    this.UI();
    // Finally we'll apply an initial mask at default settings to hide this image
    this.drawMask();
  }
  computeParentBounds() {
    this.parent_bounds = this.image.parentNode.getBoundingClientRect();

  }
  destroy() {
    console.log("destroy imageZoom");
    this.imageZoom.remove();
    this.image.style.cursor = "auto";
    this.image.removeAttribute('draggable');

  }
  
  // resizeImageZoom resizes the enlarged image
  resizeImageZoom(){
    // So let's scale up this version
    this.imageZoom.style.width = this.image.getBoundingClientRect().width*this.settings.magnification+'px';
  }
  
  // This could be inside the constructor but it's nicer on it's own I think
  UI(){
    function drag(clientX, clientY, the_this) {
      // When we move our mouse the x and y coordinates from the event
      // We subtract the left and top coordinates so that we get the (x,y) coordinates of the actualy image, where (0,0) would be the top left
      the_this.mousex = clientX - the_this.image.getBoundingClientRect().left;
      the_this.mousey = clientY - the_this.image.getBoundingClientRect().top;
      // if we're not active then don't display anything
      if (!the_this.isActive) return;
      // The drawMask() function below displays our the portion of the image that we're interested in
      the_this.drawMask();
    }
    this.image.addEventListener('mousemove',(e)=>{
      drag(e.clientX, e.clientY, this);
    });
    this.image.addEventListener('touchmove',(e)=>{
      e.preventDefault();
      var first_touch = e.targetTouches.item(0);
      drag(first_touch.clientX, first_touch.clientY, this);
    });

    function start(the_this) {
      // But it can be opening or closing, so let's pass in that information
      the_this.isExpanding = true;
      // To do that we start the maskSizer function, which calls itself until it reaches full size
      the_this.maskSizer();
      // And hide our cursor (we know where it is)
      the_this.image.classList.add('is-active');
    }
    
    // When they mousedown we open up our mask
    this.image.addEventListener('mousedown',()=>{
      start(this);
    });
    // When they mousedown we open up our mask
    this.image.addEventListener('touchstart',(e)=>{
      e.preventDefault();
      var first_touch = e.targetTouches.item(0);
      drag(first_touch.clientX, first_touch.clientY, this);
      start(this);
    });
    function end(the_this) {
      // if it's not expanding, it's closing
      the_this.isExpanding = false;
      // if the mask has already expanded we'll need to start another maskSizer to shrink it. We don't run the maskSizer unless the mask is changing
      if (the_this.isActive) the_this.maskSizer();
    }
    // if the mouse is released, close the mask
    this.image.addEventListener('mouseup',()=>{
      end(this);
    }); 
    // if the mouse is released, close the mask
    this.image.addEventListener('touchend',(e)=>{
      e.preventDefault();
      end(this);
    }); 
    // same as above, caused by us moving out of the zoom area
    this.image.addEventListener('mouseout',()=>{
      end(this);
    });
    // if the mouse is released, close the mask
    this.image.addEventListener('touchcancel',(e)=>{
      e.preventDefault();
      end(this);
    }); 
  }
  
  // The drawmask function shows us the piece of the image that we are hovering over
  drawMask(){
    // Let's use getBoundingClientRect to get the location of our images
    let image = this.image.getBoundingClientRect();
    let imageZoom = this.imageZoom.getBoundingClientRect();

    // We'll start by getting the (x,y) of our big image that matches the piece we're mousing over (which we stored from our event listener as this.mousex and this.mousey). This is a clunky bit of code to help the zooms work in a variety of situations.
    let prop_x = this.mousex/image.width*imageZoom.width*(1-1/this.settings.magnification)-image.x-window.scrollX;
    let prop_y = this.mousey/image.height*imageZoom.height*(1-1/this.settings.magnification)-image.y-window.scrollY;

    // offset scroll
    prop_x += window.scrollX;
    prop_y += window.scrollY;

    // account for relative parent offset
    this.computeParentBounds();
    var parent_offset_x = this.parent_bounds.left;
    var parent_offset_y = this.parent_bounds.top;
    prop_x += parent_offset_x;
    prop_y += parent_offset_y;

    // Shift the large image by that amount
    this.imageZoom.style.left = -prop_x+"px";
    this.imageZoom.style.top = -prop_y+"px";

    // Now we need to create our mask
    // First let's get the coordinates of the point we're hovering over
    let x=this.mousex*this.settings.magnification;
    let y=this.mousey*this.settings.magnification;
    // And create and apply our clip
    let clippy = "circle("+this.maskSize+"px at "+x+"px "+y+"px)";
    this.imageZoom.style.clipPath = clippy;
    this.imageZoom.style.webkitClipPath = clippy;
  }
  
  // We'll use the maskSizer to either expand or shrink the size of our mask
  maskSizer(){
    // We're in maskSizer so we're changing the size of our mask. Let's make the mask radius larger if the Zoombini is expanding, or shrink it if it's closing. The numbers below might need to be adjusted. It closes faster than it opens
    this.maskSize = this.isExpanding ? this.maskSize+35 : this.maskSize-40;
    // It has the form of: condition ? value-if-true : value-if-false
    // Think of the ? as "then" and : as "else"
    
    // if we've reaached max size, don't make it any larger
    if (this.maskSize >= this.settings.maskSize) {
      this.maskSize = this.settings.maskSize;
      // we'll no longer need to change the maskSize so we'll just set this.isActive to true and let our mousemove do the drawing
      this.isActive = true;
    } else if (this.maskSize<0){
      // Our mask is closed
      this.maskSize = 0;
      this.isActive = false;
      this.image.classList.remove('is-active');
    } else {
      // Or else we haven't reached a size that we want to keep yet. So let's loop it on the next available frame
      // We bind(this) here because so that the function remains in context
      requestAnimationFrame(this.maskSizer.bind(this));
    }
    // After we have the appropriate size, draw the mask
    this.drawMask();
  }
}

class ProductModal extends ModalDialog {
  constructor() {
    super();
  }
  hide() {
    super.hide();
  }
  show(opener) {
    super.show(opener);
    this.showActiveMedia();
  }
  showActiveMedia() {
    this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
        element.classList.remove('active');
      }
    );
    const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
    const activeMediaTemplate = activeMedia.querySelector('template');
    const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
    activeMedia.classList.add('active');
    activeMedia.scrollIntoView();
    const container = this.querySelector('[role="document"]');
    container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;
    if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
      activeMedia.loadContent();
  }
}
if (!customElements.get('product-modal')) {
  customElements.define('product-modal', ProductModal);
} else {
  console.log('product-modal didnt get defined');
}

if (!customElements.get('product-images-modal')) {
  customElements.define('product-images-modal', class ProductImagesModal extends ModalDialog {
    constructor() {
      console.log("images-modal constructor");
      super();
      this.glider_instances = {};
      this.zoombinis = [];
      //this.constructMagnifiers();
      this.constructSliders();
    }


    whichSlider($el) {
        if($el.classList.contains("mfg_images")) {
          return ".mfg_images";
        } else if($el.classList.contains("inhouse_images")) {
          return".inhouse_images";
        }
        return "unknown";
    }


    constructSliders() {
      console.log("constructSliders");
      var super_this = this;
      this.querySelectorAll('.contains_slider').forEach(function($el) {
        var $slider_wrap = $el.querySelector(".slider_wrap");
        var $dots = $el.querySelector(".dots");
        var $glider_prev = $el.querySelector(".glider-prev");
        var $glider_next = $el.querySelector(".glider-next");
        var instance_name = super_this.whichSlider($el)
        super_this.glider_instances[instance_name] = new Glider($slider_wrap, {
          slidesToShow: 1,
          dots: $dots,
          draggable: false,
          duration: 0,
          arrows: {
            prev: $glider_prev,
            next: $glider_next
          }
        });
        $el.addEventListener('glider-slide-visible', function(event) {
          var $slide = $el.querySelector(".glider-slide[data-gslide='"+event.detail.slide+"']");
          console.log("constructMagnifiersOn from constructSliders");
          super_this.constructMagnifiersOn($slide);
        });
      });
      this.registerTabChanges();
    }

    selectedGlider(which_is_checked) {
      let glider_key = this.translateKeys(which_is_checked);
      let glider_instance = this.glider_instances[glider_key];
      return glider_instance;
    }

    translateKeys(key) {
      let keys = {
        "which_images_ih_gallery": "inhouse_images",
        "which_images_mfg_gallery": "mfg_images"
      }
      return keys[key];
    }

    destroySliders() {
      console.log("destroySliders");
      for(var instance_name in this.glider_instances) {
        console.log("try and destroy glider "+instance_name);
        var instance = this.glider_instances[instance_name];
        instance.destroy();
      }
    }
    registerTabChanges() {
      console.log("registerTabChanges");
      var super_this = this;
      var $input_which_images = this.querySelectorAll("#which_images_gallery input[type='radio'][name='which_images_gallery']");
      $input_which_images.forEach(function($el) {
        $el.addEventListener('change', function(event) {
          var value = event.target.value;
          console.log("changed magnifier tab to: "+value);
          var query_selector;
          if(value == "ih") {
            query_selector = ".inhouse_images .glider-slide.active";
          } else if(value == "mfg") {
            query_selector = ".mfg_images .glider-slide.active";
          }
          var $slide = super_this.querySelector(query_selector);
          super_this.constructMagnifiersOn($slide);
        });
      });
    }
    constructMagnifiersOn($slide) {
      this.removePreviousMagnifiers();

      var mask_size = 200;
      if(window.innerWidth < 750) {
        mask_size = 200;
      }
      let settings = {
        'magnification':3,
        'maskSize': mask_size
      }
      let image = $slide.querySelector('img');
      var bounding_rect = $slide.getBoundingClientRect();
      // querySelectorAll produces an array of images that we pull out one by one and create a Zoombini for
      this.zoombinis.push( new Zoombini(image,settings) );
    }
    removePreviousMagnifiers() {
      console.log("removePreviousMagnifiers");
      this.zoombinis.forEach(function(zoombini) {
        zoombini.destroy();
      });
      this.zoombinis = [];
    }

    hide() {
      console.log("product-images-modal hide");
      super.hide();
      //this.destroySliders();
      this.removePreviousMagnifiers();
    }
    show(opener) {
      console.log("product-images-modal show");
      //this.constructSliders();




      var slide_target_id = opener.dataset.slideTargetId;
      var slide_target_index = opener.dataset.slideIndex;
      var tab_target_id = opener.dataset.tabTargetId;

      var $selected_tab = this.querySelector(tab_target_id);
      $selected_tab.checked = true;


      var slide_query = slide_target_id+" .glider-slide[data-gslide='"+slide_target_index+"']"
      var $slide = this.querySelector(slide_query)
      super.show(opener);
      this.glider_instances[slide_target_id].refresh(true);
      if($slide) {
        this.glider_instances[slide_target_id].scrollTo($slide.offsetLeft);
        this.constructMagnifiersOn($slide);
      } else {
        console.log("No slide for some reason");
        console.log(slide_query);
      }
      console.log("constructMagnifiersOn from show");
    }
  });
} else {
  console.log('product-images-modal didnt get defined');

}
